import React from "react";
import TextInput from "../TextInput";

export default class CodPayment extends React.Component {

    componentDidUpdate(prevProps, prevState, prevContext) {
        if (this.props.option && (this.props.option.amount === undefined || this.props.option.amount === null || this.props.option.amount === "")) {
            this.props.setFieldValue(String(this.props.optionIndex) + ".amount", Math.max(0, this.props.total - (this.props.cost + this.props.rounding) - (this.props.overpay > 0 ? this.props.overpay : 0)));
        }
    }

    render() {
        const amount = (this.props.option || {}).amount;
        return (
            <div className="payment cod-payment">
                <TextInput
                    required={this.props.required === true || (Array.isArray(this.props.required) && this.props.required.indexOf("amount") !== -1)}
                    type="number"
                    name={name + "amount"}
                    value={amount}
                    label="Utánvét díja"
                    saveChanges={(name, value) => {this.props.setFieldValue(String(this.props.optionIndex) + ".amount", value)}}
                />
            </div>
        );
    }
}